import { CSSObject } from '@chakra-ui/react';
import { StatementCardSchema } from '@/views/account/Transactions/components/ActivityStatements/components/StatementCard/styles/StatementCard.styles';

export const statementCardStyles: StatementCardSchema = {
  buttonDownload: {
    bgGradient: 'linear-gradient(180deg, #FACD33 0%, #EC9E0F 100%)',
    boxShadow: '0px 0px 0px 3px rgba(255, 255, 255, 0.25) inset',
    fontSize: '2xs',
    h: 'auto',
    letterSpacing: 'wider',
    p: '2',
    textShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.30)',
    textTransform: 'uppercase',
    color: 'alpha.600',
    _hover: {
      bg: 'beta.600',
    },

    _disabled: {
      bg: 'alpha.900',
      color: 'white',
      opacity: '1',
      px: '1.5',
      py: '1',
      textShadow: 'none',

      _hover: {
        boxShadow: 'none',
        bg: 'alpha.800',
      },
    },
  },
};

export const FlexInner: CSSObject = {
  borderBottomColor: 'whiteAlpha.300',
  minH: '12',
  py: '2',
};

export const TextMonth: CSSObject = {
  color: 'white',
  fontSize: 'sm',
  fontWeight: 'semibold',
};
